import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable } from "rxjs";

@Injectable()
export class SecurityProfileService {
  apiURL = environment.API + "/attempts";
  apiURLPublic = environment.APIpublic;

  userAdmin = false;

  httpOptions = {
    headers: new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("ticket", sessionStorage.getItem("ticket-ECM"))
      .set("Authorization", sessionStorage.getItem("tokenAuth")),
  };
  constructor(private httpClient: HttpClient) {}

  setSecurityProfileById(
    userName: string,
    appUrlToRedirect: "SURFACE" | "RM" | "WORKSPACE"
  ): Observable<any> {
    return this.httpClient.post<any>(
      this.apiURL +
        `/set-login-attempts/?userName=${userName}&r=${appUrlToRedirect}`,
      this.httpOptions
    );
  }

  resetAttempts(userName: string): Observable<any> {
    return this.httpClient.post<any>(
      this.apiURL + `/reset-attempts/${userName}`,
      this.httpOptions
    );
  }
}



// WEBPACK FOOTER //
// /app/src/app/service/securityProfile/securityProfile.service.ts